// The list below contains a set of keys that are safe not to be scrubbed if or when EUDB requirements are not met.
export var EUDBBootstrapperEventInclusionList = [
    "app",
    "bootstrapperVersion",
    "clientContextType",
    "clientType",
    "complianceEnvironment",
    "culture",
    "ErrorMessage",
    "ErrorType",
    "flights",
    "hostAppRing",
    "hostAppVersion",
    "IsClientOnline",
    "isConsumer",
    "isConsumer",
    "IsExpected",
    "lokiUrl",
    "name",
    "Perf_AuthRequestDuration",
    "Perf_GetAuthTokenDuration",
    "Perf_GetAuthTokenFromStartDuration",
    "Perf_GetLokiConfigDuration",
    "Perf_GetLokiConfigFromStartDuration",
    "Perf_GetLpcBundlesDuration",
    "Perf_GetLpcBundlesFromStartDuration",
    "Perf_GetLpeBundlesDuration",
    "Perf_GetLpeBundlesFromStartDuration",
    "Perf_InitConfigRequestDuration",
    "Perf_LpcBundleRequestDuration",
    "Perf_LpcStringsRequestDuration",
    "Perf_StartLpcDuration",
    "Perf_StartLpcFromStartDuration",
    "platform",
    "region",
    "settings",
    "versionOverride",
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm9vdHN0cmFwcGVyRXZlbnRzQ29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL01vZGVscy9Cb290c3RyYXBwZXJFdmVudHNDb25maWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNkZBLG1IQUFtSDtBQUNuSCxNQUFNLENBQUMsSUFBTSxrQ0FBa0MsR0FBb0I7SUFDakUsS0FBSztJQUNMLHFCQUFxQjtJQUNyQixtQkFBbUI7SUFDbkIsWUFBWTtJQUNaLHVCQUF1QjtJQUN2QixTQUFTO0lBQ1QsY0FBYztJQUNkLFdBQVc7SUFDWCxTQUFTO0lBQ1QsYUFBYTtJQUNiLGdCQUFnQjtJQUNoQixnQkFBZ0I7SUFDaEIsWUFBWTtJQUNaLFlBQVk7SUFDWixZQUFZO0lBQ1osU0FBUztJQUNULE1BQU07SUFDTiwwQkFBMEI7SUFDMUIsMkJBQTJCO0lBQzNCLG9DQUFvQztJQUNwQyw0QkFBNEI7SUFDNUIscUNBQXFDO0lBQ3JDLDRCQUE0QjtJQUM1QixxQ0FBcUM7SUFDckMsNEJBQTRCO0lBQzVCLHFDQUFxQztJQUNyQyxnQ0FBZ0M7SUFDaEMsK0JBQStCO0lBQy9CLGdDQUFnQztJQUNoQyx1QkFBdUI7SUFDdkIsZ0NBQWdDO0lBQ2hDLFVBQVU7SUFDVixRQUFRO0lBQ1IsVUFBVTtJQUNWLGlCQUFpQjtDQUNsQixDQUFDIn0=